import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

export const TAIL_LINE_LIST = [100, 200, 500, 1000]

export interface ServiceLogsRes {
  data?: string[]
}

export interface ServiceLogsReq {
  /** 服务标识 */
  core_service_id?: string
  /** 日志行数 */
  tail_lines?: number
}

@Injectable()
export class LogDrawerService {
  constructor (private http: Http) {

  }

  @InvokeThrottle()
  getServiceLogs (data: ServiceLogsReq) {
    return this.http.post<ServiceLogsRes>('/metric/core_service_logs', data)
  }
}
